module.exports = __webpack_public_path__ + "img/eye-in-client-king-charters.12a71464.png";